import { Components, Theme } from '@mui/material/styles';

export const flowStepConnector: Components<Theme>['MuiStepConnector'] = {
  styleOverrides: {
    line: ({ theme }) => ({
      border: 'none',
      '&.MuiStepConnector-lineVertical': {
        borderLeft: `2px solid ${theme.palette.onSurface.os300}`,
      },
      '&.MuiStepConnector-lineHorizontal	': {
        borderTop: `2px solid ${theme.palette.onSurface.os300}`,
      },
    }),
  },
};
